import React from 'react';

import styles from './styles.scss';

export default class InlineButtonPanel extends React.Component {

    render() {
        return (
            <div className={styles['panel']}>
                { this.props.children }
            </div>
        );
    }
}
